import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';

import { RxControlErrorComponent } from './control-error/rx-control-error.component';
import { RxFormControlErrorContainerDirective } from './rx-form-control-error-container.directive';
import { RxFormControlErrorsDirective } from './rx-form-control-errors.directive';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    RxFormControlErrorsDirective,
    RxControlErrorComponent,
    RxFormControlErrorContainerDirective,
  ],
  exports: [
    RxFormControlErrorsDirective,
    RxControlErrorComponent,
    RxFormControlErrorContainerDirective,
  ],
})
export class RxFormControlErrorsModule {}
